import state from './moduleCounterState'
import mutations from './moduleCounterMutations'
import actions from './moduleCounterActions'
import getters from './moduleCounterGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
